import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e75c4fb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qualityCheckInfo" }
const _hoisted_2 = { class: "total-container" }
const _hoisted_3 = {
  key: 0,
  class: "top-container"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "巡检名称：")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "巡检员：")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "巡检时间：")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "巡检单号：")
], -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "附件：")
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  class: "pictures",
  style: {"width":"100%"}
}
const _hoisted_13 = ["src", "onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "备注：")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "巡检结果：")
], -1))
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "责任人：")
], -1))
const _hoisted_18 = { key: 3 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "处理结果：")
], -1))
const _hoisted_20 = {
  key: 1,
  class: "table"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "sp-first" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("整改日期：")
const _hoisted_24 = { class: "sp-second" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "附件：", -1))
const _hoisted_26 = ["src", "onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "整改单：", -1))
const _hoisted_28 = ["src", "onClick"]
const _hoisted_29 = ["src"]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "sp-first" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("审批日期：")
const _hoisted_33 = { class: "sp-second" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "附件：", -1))
const _hoisted_35 = ["src", "onClick"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "整改单：", -1))
const _hoisted_37 = ["src", "onClick"]
const _hoisted_38 = ["src"]
const _hoisted_39 = ["src"]
const _hoisted_40 = {
  key: 2,
  class: "zg-container"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "jiange" }, null, -1))
const _hoisted_42 = /*#__PURE__*/_createTextVNode("处理完成")
const _hoisted_43 = {
  key: 3,
  class: "sh-container"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "jiange" }, null, -1))
const _hoisted_45 = { style: {"width":"100%","display":"flex","justify-content":"space-between"} }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("不通过")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_48 = { style: {"height":"100%","display":"flex","justify-content":"center","align-items":"center"} }
const _hoisted_49 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_step = _resolveComponent("van-step")!
  const _component_van_steps = _resolveComponent("van-steps")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.infodata)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _hoisted_4,
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.infodata.pointName), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_5,
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.infodata.checkName), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_6,
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.infodata.checkDate), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_7,
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.infodata.recordNo), 1)
              ])
            ]),
            (_ctx.$route.query.status != 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
              : _createCommentVNode("", true),
            (_ctx.infodata.imgFileList && _ctx.infodata.imgFileList.length !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infodata.imgFileList, (li, i) => {
                      return (_openBlock(), _createElementBlock("img", {
                        src: li,
                        key: i,
                        onClick: ($event: any) => (_ctx.previewimgfun(li))
                      }, null, 8, _hoisted_13))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _hoisted_14,
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.infodata.remark), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_15,
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  class: _normalizeClass({
                zhengchang: _ctx.infodata.status === 1,
                yichang: _ctx.infodata.status === 2,
                loujian: _ctx.infodata.status !== 1 && _ctx.infodata.status !== 2,
              })
                }, _toDisplayString(_ctx.infodata.status === 1
                  ? "正常"
                  : _ctx.infodata.status === 2
                  ? "异常"
                  : "漏检"), 3)
              ])
            ]),
            (_ctx.infodata.result != 1 && _ctx.$route.query.status != 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", null, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.infodata.rectifyName), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (
            _ctx.infodata.status && _ctx.infodata.result != 1 && _ctx.$route.query.status != 4
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass({
                _no: _ctx.infodata.status === 1,
                _yes: _ctx.infodata.status === 2,
                _resove: _ctx.infodata.status === 3,
              })
                    }, _toDisplayString(_ctx.infodata.status === 1
                  ? "未处理"
                  : _ctx.infodata.status === 2
                  ? "已处理"
                  : "已解决"), 3)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.infodata.rectifyHistory && _ctx.infodata.rectifyHistory.length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            (_ctx.infodata)
              ? (_openBlock(), _createBlock(_component_van_steps, {
                  key: 0,
                  active: _ctx.active,
                  direction: "vertical"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infodata.rectifyHistory, (li, i) => {
                      return (_openBlock(), _createBlock(_component_van_step, { key: i }, {
                        default: _withCtx(() => [
                          (li.status == 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("span", null, [
                                    _hoisted_23,
                                    _createElementVNode("span", null, _toDisplayString(li.rectifyTime && li.rectifyTime.substr(0, 16)), 1)
                                  ]),
                                  _createElementVNode("span", null, "整改人:" + _toDisplayString(li.approveName), 1)
                                ]),
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("div", null, _toDisplayString(li.remark), 1),
                                  _createElementVNode("div", null, [
                                    _hoisted_25,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(li.fileList, (item, index) => {
                                      return (_openBlock(), _createElementBlock("img", {
                                        src: item.url,
                                        key: index,
                                        class: "dellistImg",
                                        onClick: ($event: any) => (_ctx.previewimgfun(item.url))
                                      }, null, 8, _hoisted_26))
                                    }), 128))
                                  ]),
                                  _createElementVNode("div", null, [
                                    _hoisted_27,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(li.checkFileList, (item, index) => {
                                      return (_openBlock(), _createElementBlock("img", {
                                        src: item.url,
                                        key: index,
                                        class: "dellistImg",
                                        onClick: ($event: any) => (_ctx.previewimgfun(item.url))
                                      }, null, 8, _hoisted_28))
                                    }), 128))
                                  ]),
                                  _createElementVNode("img", {
                                    src: require('@/assets/zgwc.png')
                                  }, null, 8, _hoisted_29)
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("span", null, [
                                    _hoisted_32,
                                    _createElementVNode("span", null, _toDisplayString(li.approveTime && li.approveTime.substr(0, 16)), 1)
                                  ]),
                                  _createElementVNode("span", null, "审核人: " + _toDisplayString(li.approveName), 1)
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("div", null, _toDisplayString(li.remark), 1),
                                  _createElementVNode("div", null, [
                                    _hoisted_34,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(li.fileList, (item, index) => {
                                      return (_openBlock(), _createElementBlock("img", {
                                        src: item.url,
                                        key: index,
                                        class: "dellistImg",
                                        onClick: ($event: any) => (_ctx.previewimgfun(item.url))
                                      }, null, 8, _hoisted_35))
                                    }), 128))
                                  ]),
                                  _createElementVNode("div", null, [
                                    _hoisted_36,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(li.checkFileList, (item, index) => {
                                      return (_openBlock(), _createElementBlock("img", {
                                        src: item.url,
                                        key: index,
                                        class: "dellistImg",
                                        onClick: ($event: any) => (_ctx.previewimgfun(item.url))
                                      }, null, 8, _hoisted_37))
                                    }), 128))
                                  ]),
                                  (li.status === 3)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: require('@/assets/sptg.png')
                                      }, null, 8, _hoisted_38))
                                    : _createCommentVNode("", true),
                                  (li.status === 1)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        src: require('@/assets/spth.png')
                                      }, null, 8, _hoisted_39))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["active"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (
          (_ctx.$route.query.checkType == 3 && _ctx.$route.query.status == 1) ||
          (_ctx.$route.query.checkType == 0 && _ctx.infodata.flag == 1)
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createVNode(_component_van_form, { onSubmit: _ctx.onSubmit }, {
              default: _withCtx(() => [
                _createVNode(_component_van_field, {
                  class: "first-field",
                  modelValue: _ctx.remark,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.remark) = $event)),
                  rules: [{ required: true, message: '请填写处理结果' }],
                  rows: "2",
                  required: "",
                  autosize: "",
                  label: "处理结果",
                  type: "textarea",
                  maxlength: "200",
                  placeholder: "请填写处理结果",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_field, {
                  class: "second-field",
                  rules: [{ required: true, message: '请上传整改结果照片' }],
                  label: "整改结果照片",
                  required: ""
                }, {
                  input: _withCtx(() => [
                    _createVNode(_component_van_uploader, {
                      modelValue: _ctx.uploader,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.uploader) = $event)),
                      "after-read": _ctx.afterRead,
                      multiple: _ctx.$isIOS()
                    }, null, 8, ["modelValue", "after-read", "multiple"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_field, {
                  class: "three-field",
                  label: "整改单"
                }, {
                  input: _withCtx(() => [
                    _createVNode(_component_van_uploader, {
                      modelValue: _ctx.checkUploader,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checkUploader) = $event)),
                      "after-read": _ctx.afterRead,
                      multiple: _ctx.$isIOS()
                    }, null, 8, ["modelValue", "after-read", "multiple"])
                  ]),
                  _: 1
                }),
                _hoisted_41,
                _createVNode(_component_van_button, {
                  style: {"width":"100%"},
                  round: "",
                  type: "primary",
                  "native-type": "submit"
                }, {
                  default: _withCtx(() => [
                    _hoisted_42
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ]))
        : _createCommentVNode("", true),
      (
          (_ctx.$route.query.checkType == 2 && _ctx.$route.query.status == 2) ||
          (_ctx.$route.query.checkType == 0 && _ctx.infodata.flag == 2)
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
            _createVNode(_component_van_field, {
              modelValue: _ctx.remark,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.remark) = $event)),
              rows: "2",
              rules: [{ required: true, message: '请填写审核意见' }],
              required: "",
              autosize: "",
              class: "first-field",
              label: "审核意见",
              type: "textarea",
              maxlength: "200",
              placeholder: "请填写审核意见",
              "show-word-limit": ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              class: "second-field",
              label: "附件"
            }, {
              input: _withCtx(() => [
                _createVNode(_component_van_uploader, {
                  modelValue: _ctx.uploader,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.uploader) = $event)),
                  "after-read": _ctx.afterRead,
                  multiple: _ctx.$isIOS()
                }, null, 8, ["modelValue", "after-read", "multiple"])
              ]),
              _: 1
            }),
            _createVNode(_component_van_field, {
              class: "three-field",
              label: "整改单"
            }, {
              input: _withCtx(() => [
                _createVNode(_component_van_uploader, {
                  modelValue: _ctx.checkUploader,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.checkUploader) = $event)),
                  "after-read": _ctx.afterRead,
                  multiple: _ctx.$isIOS()
                }, null, 8, ["modelValue", "after-read", "multiple"])
              ]),
              _: 1
            }),
            _hoisted_44,
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_van_button, {
                style: {"width":"48%"},
                round: "",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.examine(2)))
              }, {
                default: _withCtx(() => [
                  _hoisted_46
                ]),
                _: 1
              }),
              _createVNode(_component_van_button, {
                style: {"width":"48%"},
                round: "",
                type: "primary",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.examine(1)))
              }, {
                default: _withCtx(() => [
                  _hoisted_47
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_van_overlay, {
      show: _ctx.show,
      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.show = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("img", {
            src: _ctx.previewimg,
            style: {"width":"100%"}
          }, null, 8, _hoisted_49)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}